const Cookies = require('cookies-js');

const PCWorldClosureAnalyticsInit = () => {
  const analyticsCookie = Cookies.get('redirectionAnalytics');
  if (analyticsCookie) {
    try {
      const analyticsObj = JSON.parse(analyticsCookie);
      if (typeof analyticsObj === 'object') {
        const { referringUrl, reason, category } = analyticsObj;
        if (
          typeof referringUrl === 'string' &&
          typeof reason === 'string' &&
          typeof category === 'string'
        ) {
          window.digitalData.page.redirect = {
            redirectType: 301,
            redirectReason: reason,
            redirectCategory: category
          };
          window.digitalData.page.referringURL = referringUrl;
        }
      } else {
        throw new Error('analytics cookie not set or not object');
      }
    } catch (e) {
      console.error('error reading analytics data: ', e);
    }
  }
};

export default PCWorldClosureAnalyticsInit;
